var scope_0 = require('/Users/stephanedeuvaert/Sites/approov-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/16377d0e4d9c6eb2b0af2fcd4eae951b.js').default;
var scope_1 = require('/Users/stephanedeuvaert/Sites/approov-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1642546c9f832c9678c3b9e685a69c74.js').default;
var scope_2 = require('/Users/stephanedeuvaert/Sites/approov-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/20b25fe91f457be27f7f27f25e605528.js').default;
var scope_3 = require('/Users/stephanedeuvaert/Sites/approov-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/27affde87e21af9c3b61e7b9b1862266.js').default;
var scope_4 = require('/Users/stephanedeuvaert/Sites/approov-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/602faa98f5ba93701bb7b7c5bcf26700.js').default;
var scope_5 = require('/Users/stephanedeuvaert/Sites/approov-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/72b71fb344579e3d2da6be6ae82ce5d1.js').default;
var scope_6 = require('/Users/stephanedeuvaert/Sites/approov-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6 )
    